import { createApp } from 'vue'
import App from './App.vue'

import router from './router'
import store from './store'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// 基础样式（建议顺序：reset → variables → UI覆盖）
import './assets/css/reset.min.css'
import './assets/css/variables.scss'
import './assets/css/element-overrides.scss'

const app = createApp(App)

app.use(store)
app.use(router)
app.use(ElementPlus)

app.mount('#app')